/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */
import Line from '@fusioncharts/charts/src/dataset/line';
import { pluck, pluckNumber, HUNDREDSTRING, getDashStyle } from '@fusioncharts/core/src/lib';
import { addDep } from '@fusioncharts/core/src/dependency-manager';
import multiaxisAnimation from './index.animation';
addDep({
  name: 'multiAxislineAnimation',
  type: 'animationRule',
  extension: multiaxisAnimation
});
/**
 * Class for MultiAxisLine chartAPI
 */
class MultiAxisDataset extends Line {
  /**
   * Sets the type of the component
   * @return {string} type
   */
  getType () {
    return 'dataset';
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'multiaxisline';
  }
  /**
   * Function to configure the data given by the user at the dataset level
   * @param {Object} datasetJSON JSON for dataset configurations
   * @return {boolean} False if no datasetJSON is present
   */
  configure (datasetJSON) {
    if (!datasetJSON) {
      return false;
    }
    this.trimData(datasetJSON);
    this.config.JSONData = datasetJSON;
    super.configure(datasetJSON);
  }
  /**
   * Function to parse the data given by the user at the dataset level
   */
  parseAttributes () {
    var dataSet = this,
      jsonData = dataSet.config.JSONData,
      dataSetConfig = dataSet.config,
      chartAttr = dataSet.getFromEnv('chart-attrib'),
      axis = dataSet.getFromEnv('axisData'),
      lineDashStyle,
      lineDashed;

    super.parseAttributes();

    dataSetConfig.linethickness = pluckNumber(jsonData.linethickness, axis.linethickness,
      chartAttr.linethickness, 2);
    dataSetConfig.lineDashLen = pluckNumber(jsonData.linedashlen, axis.linedashlen,
      chartAttr.linedashlen, 5);
    dataSetConfig.lineDashGap = pluckNumber(jsonData.linedashgap, axis.linedashgap,
      chartAttr.linedashgap, 4);
    dataSetConfig.alpha = pluckNumber(jsonData.alpha, axis.linealpha,
      chartAttr.linealpha, HUNDREDSTRING);
    dataSetConfig.linecolor = pluck(jsonData.color, axis.linecolor, axis.color, chartAttr.linecolor,
      dataSetConfig.plotColor);

    dataSetConfig.legendSymbolColor = dataSet.getName() === 'line' ? dataSetConfig.lineColor
      : dataSetConfig.plotFillColor;
    lineDashed = pluckNumber(jsonData.dashed, axis.linedashed, chartAttr.linedashed);// eslint-disable-line good-practices/no-single-usage-variable
    lineDashStyle = getDashStyle(dataSetConfig.lineDashLen, dataSetConfig.lineDashGap);// eslint-disable-line good-practices/no-single-usage-variable
    dataSetConfig.anchorbordercolor = pluck(jsonData.anchorbordercolor, jsonData.color, axis.color,
      chartAttr.anchorbordercolor, dataSetConfig.lineColor, dataSetConfig.plotColor);
    dataSetConfig.lineDashStyle = lineDashed
      ? lineDashStyle : 'none';
  }
}
export default MultiAxisDataset;
